// Maps a (rebranded) model id to a vendor brand logo in /public by keyword.
// Returns the logo path, or null to fall back to a generic icon.
const MODEL_BRAND_ICONS: { test: RegExp; icon: string }[] = [
  { test: /gpt|openai|codex|chatgpt/i, icon: '/openai.svg' },
  { test: /claude|anthropic|sonnet|opus|haiku/i, icon: '/claude-color.svg' },
  { test: /gemini|gemma|palm|bison|google/i, icon: '/gemini-color.svg' },
  { test: /deepseek/i, icon: '/deepseek.svg' },
  { test: /qwen|tongyi/i, icon: '/qwen-color.svg' },
  { test: /llama|meta/i, icon: '/llama.svg' },
  { test: /mistral|mixtral|codestral|magistral|ministral/i, icon: '/mistral.svg' },
  { test: /grok|xai/i, icon: '/grok.svg' },
  { test: /kimi|moonshot/i, icon: '/moonshotai.svg' },
  { test: /glm|chatglm|zhipu/i, icon: '/chatglm-color.svg' },
  { test: /cohere|command-?r/i, icon: '/cohere.svg' },
  { test: /perplexity|sonar/i, icon: '/perplexity.svg' },
  { test: /nemotron|nvidia/i, icon: '/nvidia-color.svg' },
  { test: /falcon/i, icon: '/falcon.svg' },
  { test: /\bphi\b/i, icon: '/phi.svg' },
  { test: /\byi[-\d]/i, icon: '/yi.svg' },
];

export function getModelBrandIcon(modelId: string): string | null {
  if (!modelId) return null;
  const match = MODEL_BRAND_ICONS.find(entry => entry.test.test(modelId));
  return match ? match.icon : null;
}
